module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "c-page-standings u-pad-y-1"
  }, [(_vm.countdownFinished) ? _c('div', {
    staticClass: "c-page--container c-marg--before-footer u-relative"
  }, [_c('app-title', {
    staticClass: "c-big-title",
    attrs: {
      "logo": _vm.contentGlobal.secondaryLogo,
      "title": _vm.contentPage.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-relative u-fit-w"
  }, [_c('section', {
    staticClass: "u-fit-w u-flex--x u-flex--center u-align-center u-flex--y@md"
  }, _vm._l((_vm.videoGames), function(game, index) {
    return _c('app-btn-filter', {
      key: index,
      staticClass: "u-flex--x u-block@md u-w2of3@md u-fit-w@sm u-marg-l-sm u-uppercase u-marg-x-auto@md u-marg-x-xxxs@lg",
      class: [parseInt(_vm.filterVideoGame.id, 10) === parseInt(game.id) ? 'is-selected' : ''],
      on: {
        "click": function($event) {
          _vm._onFilterVideoGame(parseInt(game.id))
        }
      }
    }, [_c('h2', {
      staticClass: "u-inline-block u-fit"
    }, [_c('img', {
      staticClass: "is-img",
      attrs: {
        "src": game.logo_light || '/static/game/game-franchise.png',
        "alt": game.name
      }
    })])])
  }))]), _vm._v(" "), _c('h3', {
    staticClass: "u-marg-t-xxxl u-relative u-align-center u-color--red u-uppercase t-text--xxl t-text--bold",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies[parseInt(_vm.filterVideoGame.id, 10) === 0 ? 'overallTitle' : 'gameTitle'].replace(':videoGame', _vm.filterVideoGame.name))
    }
  }), _vm._v(" "), (_vm.teams.length > 0) ? _c('table', {
    staticClass: "u-marg-t-xxl u-fit-w"
  }, [_c('tr', {
    staticClass: "u-pad-a-1 u-align-center u-hide@md"
  }, [_c('td', {
    staticClass: "t-text--sm t-text--bold u-align-left u-uppercase u-pad-l-xxs u-valign-middle"
  }, [_c('span', {
    staticClass: "u-marg-l-xxxs u-inline-block",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies.rank)
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "t-text--sm t-text--bold u-pad-l-xs u-align-left u-uppercase u-valign-middle u-pad-y-lg ",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies.team)
    }
  }), _vm._v(" "), (parseInt(_vm.filterVideoGame.id, 10) !== 1) ? _c('td', {
    staticClass: "u-w1of10 t-text--sm t-text--bold u-uppercase u-valign-middle"
  }) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "u-w1of10 t-text--sm t-text--bold u-uppercase u-valign-middle"
  }, [(parseInt(_vm.filterVideoGame.id, 10) !== 0) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies.wins)
    }
  }) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "u-w1of10 t-text--sm t-text--bold u-uppercase u-valign-middle"
  }, [(parseInt(_vm.filterVideoGame.id, 10) !== 0) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies.losses)
    }
  }) : _vm._e()]), _vm._v(" "), (parseInt(_vm.filterVideoGame.id, 10) === 1) ? _c('td', {
    staticClass: "u-w1of10 t-text--sm t-text--bold u-uppercase u-valign-middle"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies.draw)
    }
  })]) : _vm._e(), _vm._v(" "), _c('td', {
    attrs: {
      "cclass": "u-w1of10 t-text--sm t-text--bold u-uppercase u-valign-middle"
    }
  }, [(parseInt(_vm.filterVideoGame.id, 10) !== 0) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies.winPercent)
    }
  }) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "u-w1of10 t-text--sm t-text--bold u-uppercase u-valign-middle"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies.points)
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.teams), function(match, index) {
    return [_c('app-teams-table-row', {
      key: index,
      class: {
        'c-team-profile__bg': (index % 2) === 1
      },
      attrs: {
        "team": match,
        "index": index,
        "contentGlobal": _vm.contentGlobal,
        "contentPage": _vm.contentPage
      }
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "c-player__bg-line u-height-1 u-hide@md",
      attrs: {
        "colspan": "7"
      }
    })]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "c-player__bg-line u-height-1 u-hide u-block@md"
    })])]
  })], 2) : _c('div', {
    staticClass: "u-marg-t-xxl u-flex u-flex-ai--center u-flex-jc--center"
  }, [_vm._v("No team found for this game.")])], 1) : _c('app-season-coming-soon', {
    staticClass: "c-page--container c-marg--before-footer u-relative"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "c-player__bg-line u-height-1 u-hide@md",
    attrs: {
      "colspan": "7"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "c-player__bg-line u-height-1 u-hide u-block@md"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcbf823c"}!./src/scripts/components/page-standings/template.html
// module id = 942
// module chunks = 0